import { gql } from 'apollo-angular';

/**
 * AdditionalOrderInformationTemplate schema
 */
export class FileSchema {
	/**
	 * Mutation to add the avatar file
	 */
	static readonly addAvatarFile = gql`
		mutation AddAvatarFile($avatarFile: FileInput!) {
			addAvatarFile(avatarFile: $avatarFile) {
				filePath
				storageFileNumber
				uid
			}
		}
	`;

	/**
	 * Mutation to add the singature file
	 */
	static readonly addSignatureFile = gql`
		mutation AddSignatureFile($signatureFile: FileInput!) {
			addSignatureFile(signatureFile: $signatureFile) {
				filePath
				storageFileNumber
				uid
			}
		}
	`;
}
